import { IButtonStyles, IIconStyles, IStackItemStyles, IStackStyles, ITextStyles } from 'office-ui-fabric-react';
import * as enums from '../../enums';
import { ITicket } from './model';

export const ticketContainer: IStackItemStyles = {
    root: {
        height: '80px',
        minWidth: '150px',
        padding: '20px',
        borderRadius: 10,
        backgroundColor: '#D8D8D6',
        alignItems: 'center'
    }
};

export const largeBlueFont: IStackItemStyles = {
    root: {
        fontSize: '25px',
        color: '#2B3948',
        margin: 'auto'
    }
};

export const functionButtonStyles: IStackItemStyles = {
    root: {
        padding: 10,
        textAlign: 'center'
    }
};

export const fullScreenStyles: IStackItemStyles = {
    root: {
        zIndex: 1,
        top: 0,
        bottom: 0,
        position: 'fixed',
        left: 0,
        display: 'flex',
        right: 0
    }
};

export const expand: IStackItemStyles = {
    root: {
        flex: 1,
        position: 'relative',
        background: '#E6E7E8',
        paddingTop: '3vw',
        paddingRight: '3vw'
    }
};

export const oneFieldRow: IStackItemStyles = {
    root: {
        flex: 1,
        justifyContent: 'space-between',
        alignItems: 'center',
        color: '#4A9491',
        marginBottom: '2px'
    }
};

export const titleStyles: IStackStyles = {
    root: {
        background: '#2C3949',
        justifyContent: 'space-between',
        padding: '0 3vw',
        color: 'white'
    }
};

export const footerStyles: IStackStyles = {
    root: {
        position: 'fixed',
        background: '#2C3949',
        height: '20px',
        width: '100%',
        bottom: 0
    }
};

export const statisticsContent = {
    root: {
        margin: '10px'
    }
};

export const getTicketColor = (ticket: ITicket) => {
    if (ticket.state === enums.ticketState.Serviced) {
        return '#5FBA7D';
    }

    if (ticket.state === enums.ticketState.Invited) {
        return '#FFF4CE';
    }

    return '#F3F2F1';
};

export const queueControlStyle: IStackItemStyles = {
    root: {
        width: '20vw',
        minWidth: '350px',
        maxWidth: '350px',
        flex: 1,
        overflow: 'auto',
        display: 'flex',
        flexDirection: 'column'
    }
};

export const queueContainerStyle: IStackItemStyles = {
    root: {
        width: '80vw'
    }
};

export const ticketsListStyles: IStackItemStyles = {
    root: {
        padding: 10
    }
};

export const currentPatientPanelStyle: IStackItemStyles = {
    root: {
        marginTop: 30
    }
};

export const currentPatientPanelInformationStyle: IStackItemStyles = {
    root: {
        height: 'auto',
        textAlign: 'center'
    }
};

export const stickyContainer: IStackItemStyles = {
    root: {
        margin: 'auto',
        background: 'white'
    }
};

export const cautionModalContinueButton: IButtonStyles = {
    root: {
        margin: '20px',
        padding: '5px 10'
    },
    textContainer: {
        textAlign: 'center'
    }
};

export const cautionModalText: ITextStyles = {
    root: {
        textAlign: 'center',
        fontSize: '5vw'
    }
};

export const centeredModal: IStackItemStyles = {
    root: {
        margin: 'auto',
        maxWidth: '500px',
        border: '1px #4A9491 solid',
        borderRadius: '10px',
        //center
        background: 'white',
        width: '100%',
        display: 'flex',
        flexFlow: 'column nowrap',
        alignItems: 'stretch'
    }
};

export const closeIcon: IStackItemStyles = {
    root: {
        position: 'absolute',
        right: '6px',
        top: '6px'
    }
};

export const absoluteContainer: IStackItemStyles = {
    root: {
        overflow: 'auto',
        top: '35px',
        padding: 10,
        background: 'white',
        zIndex: 1,
        position: 'absolute',
        width: '100%',
        left: 0
    }
};

export const scrollParent: IStackItemStyles = {
    root: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column'
    }
};

export const scrollY: IStackItemStyles = {
    root: {
        flex: 1,
        width: '100%',
        overflowY: 'scroll',
        overflowX: 'hidden',
        alignItems: 'center',
        position: 'absolute',
        top: 0,
        bottom: 0,
        marginBottom: '20px'
    }
};

export const queueSettingsStyle: IStackItemStyles = {
    root: {
        width: '20vw'
    }
};

export const transparentButton: IButtonStyles = {
    root: {
        minHeight: '3vw',
        margin: '2px',
        background: 'transparent',
        borderRadius: '10px',
        fontFamily: 'Neo Sans Pro',
        border: '1px solid #4A9491',
        color: '#4A9491'
    },
    rootHovered: {
        backgroundColor: 'none',
        color: '#4A9491'
    }
};

export const blueButton: IButtonStyles = {
    root: {
        minHeight: '3vw',
        margin: '2px',
        border: 'none',
        backgroundColor: '#0071bc',
        color: 'white',
        borderRadius: '10px'
    },
    rootHovered: {
        backgroundColor: 'none',
        color: 'white'
    }
};
export const greenButton: IButtonStyles = {
    root: {
        minHeight: '3vw',
        margin: '2px',
        border: 'none',
        backgroundColor: '#009245',
        color: 'white',
        borderRadius: '10px'
    },
    rootHovered: {
        backgroundColor: 'none',
        color: 'white'
    }
};
export const redButton: IButtonStyles = {
    root: {
        minHeight: '3vw',
        margin: '2px',
        border: 'none',
        backgroundColor: '#C1272D',
        color: 'white',
        borderRadius: '10px'
    },
    rootHovered: {
        backgroundColor: 'none',
        color: 'white'
    }
};
export const ticketButton: IButtonStyles = {
    root: {
        borderRadius: 10,
        borderColor: '#4A9491',
        minHeight: '50px',
        height: 'auto',
        width: '100%',
        color: '#4A9491'
    }
};

export const locationStateUserIcon: IIconStyles = {
    root: {
        fontSize: '25px',
        margin: 'auto',
        padding: '2px',
        cursor: 'pointer'
    }
};
export const activeLocationStateCircle: IIconStyles = {
    root: {
        fontSize: '25px',
        color: '#009245',
        margin: 'auto',
        padding: '2px',
        cursor: 'default',
        paddingTop: '8px'
    }
};
export const inActiveLocationStateCircle: IIconStyles = {
    root: {
        fontSize: '25px',
        color: '#C1272D',
        margin: 'auto',
        padding: '2px',
        cursor: 'default'
    }
};

export const queuesFilterDropdownStyles = {
    root: { minWidth: '100%', maxWidth: '300px' }
};
